import { useEffect } from 'react';
import { App as CapApp, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';

const ROUTE_MAP: Record<string, string> = {
  '/events/new': '/events?new=1',
  '/events': '/events',
  '/wishlist': '/wishlist',
  '/recipes/new': '/recipes?new=1',
  '/recipes': '/recipes',
  '/notifications': '/notifications',
};

function routeForPath(pathname: string): string | null {
  if (ROUTE_MAP[pathname]) return ROUTE_MAP[pathname];
  if (pathname.startsWith('/events/')) return pathname;
  if (pathname.startsWith('/recipes/')) return pathname;
  return pathname || null;
}

export function useDeepLinks(): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let handle: { remove: () => void } | null = null;

    CapApp.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      try {
        const url = new URL(event.url);
        if (url.protocol !== 'hostly:') return;
        const path = `/${url.host}${url.pathname}`.replace(/\/+/g, '/');
        const target = routeForPath(path);
        if (target) navigate(target);
      } catch {
        // url malformada; ignora
      }
    }).then((h) => { handle = h; });

    return () => {
      handle?.remove();
    };
  }, [navigate]);
}
